export enum ExperienceStatus {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
  ARCHIVING = 'archiving',
  DRAFT = 'draft',
}

export default ExperienceStatus;
